import { Component, Input } from "@angular/core";
import { CDN_IMAGES } from '../../constants/param-constants';
import { getCustomerServiceInfo } from '../../constants/customer-service-info';
import { HeaderContent } from "../../app/models/headerContent";

@Component({
    selector: 'brand-header',
    templateUrl: './brand-header.html',
})
export class BrandHeaderComponent {
  CDN_IMAGES = CDN_IMAGES;

  @Input() content: Partial<HeaderContent> | null = null;

  get brandLogo(): string {
    return this.content?.icon || CDN_IMAGES.BRAND_LOGO;
  }

  get dynamicPhoneNumber(): string {
    return this.content?.dynamicPhoneNumber || getCustomerServiceInfo(this.content?.currency).phone;
  }

  constructor(
  ) {

  }

}